export interface FitterWsToken {
  access_token: string;
  expires_in: number;
  token_type: string;
  scope: string;
  date: Date;
}

export interface FitterWsError {
  error: string;
  error_description: string;
}

export interface FitterServiceConfig {
  [insurerId: string]: FitterServiceBrandConfig;
}

export interface FitterServiceBrandConfig {
  [brandId: string]: FitterServiceBrandAuthConfig;
}

export interface FitterServiceBrandAuthConfig {
  rootUrl: string;
  authUrl: string;
  credentials: FitterServiceCredentials;
}

export interface FitterServiceCredentials {
  client_id: string;
  client_secret: string;
  grant_type: string;
  scope?: string;
  audience?: string;
}
